import { htmlDecode } from '@vue-storefront/core/filters/html-decode'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { storeCanonicalHref } from 'theme/helpers/canonical'

function pathFromRouteLink (routeLink) {
  if (!routeLink) return ''
  if (typeof routeLink === 'string') return routeLink.split('?')[0]
  if (typeof routeLink === 'object' && routeLink.path) {
    const clean = String(routeLink.path).split('?')[0]
    return clean.startsWith('/') ? clean : `/${clean}`
  }
  return ''
}

/**
 * BreadcrumbList for the visible trail. The last crumb is the current page name.
 * A parent that links to the same URL is dropped so the page is not labeled twice.
 */
export function breadcrumbListJsonLd ({ paths, current, currentPath }) {
  const storeView = currentStoreView()
  const items = []
  const seen = new Set()

  for (const crumb of paths || []) {
    const name = htmlDecode(crumb && crumb.name).trim()
    const path = pathFromRouteLink(crumb && crumb.route_link)
    if (!name || !path) continue
    const item = storeCanonicalHref(storeView, { path })
    if (!item || seen.has(item)) continue
    seen.add(item)
    items.push({ name, item })
  }

  const currentName = htmlDecode(current).trim()
  const currentUrl = currentPath ? storeCanonicalHref(storeView, { path: currentPath }) : ''
  if (currentName) {
    // A parent crumb sometimes uses the same URL as the page (category url_path
    // equals the product). Keep the visible page name as the last item.
    if (currentUrl) {
      for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].item === currentUrl) items.splice(i, 1)
      }
    }
    const last = items[items.length - 1]
    if (!(last && last.name === currentName)) {
      items.push({ name: currentName, item: currentUrl })
    } else if (currentUrl) {
      last.item = currentUrl
    }
  }

  if (items.length < 2) return null

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((entry, index) => {
      const listItem = {
        '@type': 'ListItem',
        position: index + 1,
        name: entry.name
      }
      if (entry.item) listItem.item = entry.item
      return listItem
    })
  }
}
